import { authAxios as axios } from "api-generate-types/src/axios";

import config from "config/global";

export interface IUserResponse {
  forenames: string;
  id: string;
  name: string;
  portalGuid: string;
  role: string;
  surname: string;
  agencies: IAgencyPermission[];
}

export interface IAgencyPermission {
  name: string;
  id: number;
  agencyId: number;
  allowNudge: boolean;
  nudgeAllowed: boolean;
  allowSelfSuggest: boolean;
  suggestAllowed: boolean;
  performersReceiveBreakdownEmails: boolean;
}

export type GetAgencies = (
  abortController?: AbortController
) => Promise<IAgencyPermission[]>;

class AgentsService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public getAgencies: GetAgencies = async (abortController) => {
    const response = await axios.get<IUserResponse>(`${this.url}/whoami`, {
      method: "get",
      signal: abortController?.signal,
    });

    return response.data.agencies;
  };
}

export default new AgentsService({
  url: config.liteAgentApiUrl,
});
